<template>
  <div class="action-buttons-report">
    <c-btn
      background="#00A645"
      :loading="ajaxCustomer"
      @click="sendToCustomer">
      <svg class="icon">
        <use xlink:href="/img/icons/icons-sprite.svg#send" />
      </svg>
      Send to Customer
    </c-btn>
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';

export default Vue.extend({
  props: {
    customerSended: {
      type: Boolean,
      default: () => false,
    },
    lspSended: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    ajaxCustomer: false,
  }),
  components: {
    'c-btn': () => import('@/components/button/index.vue'),
  },
  methods: {
    sendToCustomer() {
      this.ajaxCustomer = true;
      Api.reports.sendReport.customer(this.$route.params.id).then(() => {
        this.$root.$emit('notification', {
          message: 'Notification was successfully sended to Customer',
          type: 'info',
          show: true,
        });
      }).catch(() => {
        this.$root.$emit('notification', {
          message: 'Error while sending notification',
          type: 'error',
          show: true,
        });
      }).finally(() => {
        this.ajaxCustomer = false;
      });
    },
  },
});
</script>

<style lang="scss">
  .action-buttons-report {
    display: flex;

    >*+* {
      margin-left: 10px;
    }
  }
</style>
